const bellacloud = {
  portugues: {
    title: 'Meu BELLA CLOUD',
    subTitle: 'Sua pasta na nuvem: guarde fotos, vídeos, making-of e lives das suas modelos favoritas.',
    descriptionWellcome: `
      <p>
      O <strong>Bella Cloud</strong> é a sua pasta na nuvem dentro do <strong>Bella da Semana</strong>. Salve as fotos, os vídeos, os making-of e as lives que você mais gosta e organize tudo em álbuns, do seu jeito.
      </p>
      <p>
      Seus álbuns nascem privados: só você vê. Se quiser, compartilhe um álbum com os outros assinantes, que podem curtir e comentar.
      </p>
      <p>
      O Bella Cloud faz parte da sua assinatura, em todos os planos.
      </p>`,
    commentBox: 'Últimos comentários',
    commentAllBox: 'Veja todos os comentários',
    topAlbuns: 'Top Álbuns',
    othersAlbums: 'Veja os álbuns de outros assinantes',
    seeAllTops: "Ver mais",
    notMyAlbuns: "Você ainda não tem nenhum álbum. Crie o primeiro em “Novo álbum”.",
    by: "por",
    linkLogin: 'Entre na sua conta e crie os seus álbuns.',
    titleWellcome: "Seja bem vindo ao Bella Cloud",
    yoursComment: 'Deixe seu comentário',
    yourNickname: 'Seu nickname é',
    notYourNickName: 'não é',
    alterNickName: 'clique aqui para alterar',
    inputComment: 'Escreva seu comentário aqui',
    button: 'Enviar',
    subscriber: 'Assinante',
    formNewsCheck: 'Receber a newsletter do Bella da Semana',
    wroteOn: 'escreveu em',
    titleTopsPage: 'Bella Cloud - Top Álbuns',
    seeMore: "Veja mais",
    titleModal: "Criar Novo Álbum",
    formResetNameAlbum: "Nome do Album",
    albumPublic: "Compartilhar com outros assinantes",
    btnSendNewAlbum: "Salvar",
    btnClose: "Fechar",
    saveBellaCloud: 'Salvar no BellaCloud',
    addAlbum: 'Adicionar',
    newAlbum: 'Novo álbum',        
    saveAlbumInfo: 'Clique no álbum para adicionar ou tirar o item',
    successBellaCloudPhoto: "Item salvo no álbum!",
    successRemoved: "Item tirado do álbum.",
    errorBellaCloudPhoto: "Não foi possível salvar o item.",
    loginToSave: 'Entre na sua conta para salvar no Bella Cloud.',
    onlySubscribers: 'O Bella Cloud é exclusivo para assinantes.',
    subscribe: 'Assine',
    login: 'Entrar',
    topalbum: "Top Álbuns",
    photos: 'Fotos',
    video: 'Vídeos',
    makingOf: 'Making of',
    lives: 'Lives',
    emptyTab: 'Nada salvo aqui ainda.',
    lockedItem: 'Exclusivo para assinantes',
    lockedMakingOf: 'Making of disponível nos planos que incluem making of',
    lockedLive: 'Live exclusiva para assinantes Gold',
    removeItem: 'Tirar do álbum',
    confirmDeleteAlbum: 'Apagar este álbum? Os itens salvos nele saem junto.',
    noFavorites: 'Você ainda não favoritou nenhuma modelo.',
    goBackAlbuns: 'Voltar para os Álbuns',
    goFavoriteModels: 'Modelos Favoritas',
    deletePasta: 'Deletar',
    editPasta: 'Editar',
    answer: 'Responder',
    yourName: 'Seu nome',
    yourEmail: 'Seu email',
    buttonSaveOrder : 'Salvar ordenação',
    orderSaved: 'Ordem salva!',
    orderError: 'Não foi possível salvar a ordem.'
  },
  ingles: {
    title: 'My BELLA CLOUD',
    subTitle: 'Your cloud folder: keep photos, videos, making-ofs and lives of your favorite models.',
    commentAllBox: 'See all comments',
    descriptionWellcome: `
    <p>
    <strong>Bella Cloud</strong> is your cloud folder inside <strong>Bella Club</strong>. Save the photos, videos, making-ofs and lives you like best and organize them in albums, your way.
    </p>
    <p>
      Your albums start private: only you can see them. If you want, share an album with other subscribers, who can like and comment on it.
    </p>
    <p>
      Bella Cloud is part of your subscription, on every plan.
    </p>`,
    commentBox: 'Latest comments',
    topAlbuns: 'Top Albums',
    othersAlbums: "See other subscribers' albums",
    seeAllTops: "See more",
    notMyAlbuns: "You don't have any albums yet. Create your first one with “New album”.",
    by: "by",
    linkLogin: 'Log in and create your albums.',
    titleWellcome: "Welcome to Bella Cloud",
    yoursComment: 'Leave your comment',
    yourNickname: 'Your nickname is',
    notYourNickName: 'Is not',
    alterNickName: 'Click here to change',
    inputComment: 'Write your comment here',
    button: 'Send',
    subscriber: 'Subscriber',
    formNewsCheck: 'Receive the Bella Club newsletter',
    wroteOn: 'wrote on',
    titleTopsPage: 'Bella Cloud - Top Albums',
    seeMore: "See more",
    titleModal: "Create New Album",
    formResetNameAlbum: "Name",
    albumPublic: "Share with other subscribers",
    btnSendNewAlbum: "Save",
    btnClose: "Close",
    saveBellaCloud: 'Save to BellaCloud',
    newAlbum: 'New album',        
    saveAlbumInfo: 'Click an album to add or remove the item',
    addAlbum: 'Add',
    successBellaCloudPhoto: "Item saved to the album!",
    successRemoved: "Item removed from the album.",
    errorBellaCloudPhoto: "Could not save the item.",
    loginToSave: 'Log in to save to Bella Cloud.',
    onlySubscribers: 'Bella Cloud is exclusive to subscribers.',
    subscribe: 'Subscribe',
    login: 'Log in',
    topalbum: "Top Albums",
    photos: 'Photos',
    video: 'Videos',
    makingOf: 'Making of',
    lives: 'Lives',
    emptyTab: 'Nothing saved here yet.',
    lockedItem: 'Exclusive to subscribers',
    lockedMakingOf: 'Making-of available on plans that include making-ofs',
    lockedLive: 'Live exclusive to Gold subscribers',
    removeItem: 'Remove from album',
    confirmDeleteAlbum: 'Delete this album? The items saved in it go with it.',
    noFavorites: "You haven't favorited any model yet.",
    goBackAlbuns: 'Back to albums',
    goFavoriteModels: 'Favorite Models',
    deletePasta: 'Delete',
    editPasta: 'Edit',
    answer: 'Answer',
    yourName: 'Your name',
    yourEmail: 'Your e-mail',
    buttonSaveOrder : 'Save ordering',
    orderSaved: 'Order saved!',
    orderError: 'Could not save the order.'    
  }
}

export default bellacloud
